import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var ConstructionSiteComponent = /** @class */ (function () {
    function ConstructionSiteComponent(requestService, requestV2Service, globalDataService) {
        this.requestService = requestService;
        this.requestV2Service = requestV2Service;
        this.globalDataService = globalDataService;
        this.subjects = [];
        this.remarkEnabled = false;
        this.dueRealisedNumber = 0;
        this.dueEchueNumber = 0;
        this.worksite = null;
        this.owner = null;
        this.status = 'loading';
    }
    ConstructionSiteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.projectSubscription = this.globalDataService
            .getCurrentProject()
            .subscribe(function (project) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!project || this.currentProject) {
                    return [2 /*return*/];
                }
                this.currentProject = project;
                this.currentProject._related._project_user_roles.forEach(function (userR) {
                    if (_this.worksite !== null && _this.owner !== null) {
                        return;
                    }
                    if (userR.project_role.name === 'worksite') {
                        _this.worksite = userR.user;
                    }
                    if (userR.project_role.name === 'owner') {
                        _this.owner = userR.user;
                    }
                });
                this.status = 'idle';
                this.fetchAndFormatSubjects();
                return [2 /*return*/];
            });
        }); });
    };
    ConstructionSiteComponent.prototype.fetchAndFormatSubjects = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var subjectResults, apiSubjects;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestV2Service
                            .getProjectSubjects(this.currentProject.id, true)];
                    case 1:
                        subjectResults = _a.sent();
                        apiSubjects = subjectResults.items;
                        this.subjects = apiSubjects;
                        this.subjects.forEach(function (subject) {
                            if (subject.dates.resolution) {
                                _this.dueRealisedNumber += 1;
                            }
                            var date = subject.dates.resolution || subject.dates.due || subject.dates.creation;
                            if (new Date(date).getTime() < new Date().getTime()) {
                                _this.dueEchueNumber += 1;
                            }
                            if (subject._related.users[0] !== null) {
                                subject._related.users.forEach(function (concernedUser) {
                                    _this.currentProject._related._project_user_roles.forEach(function (userR) {
                                        if (userR.user.id === concernedUser.id) {
                                            concernedUser.role = userR.project_role.name;
                                        }
                                    });
                                });
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstructionSiteComponent.prototype.onUpdateListSubjects = function (subject) {
        if (subject) {
            this.fetchAndFormatSubjects();
        }
        this.remarkEnabled = false;
    };
    ConstructionSiteComponent.prototype.ngOnDestroy = function () {
        this.projectSubscription.unsubscribe();
    };
    return ConstructionSiteComponent;
}());
export { ConstructionSiteComponent };
